import { Component } from '@angular/core';
import { BlogNewsComponent } from '@prekog/common-ui';

@Component({
    selector: 'p-blog',
    templateUrl: './blogpiece.component.html',
    styleUrls: ['./blogpiece.component.scss'],
    standalone: true,
    imports: [BlogNewsComponent]
})
export class BlogPieceComponent {}
